module.exports = __webpack_public_path__ + "img/inventory-types.7517a636.png";